/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer } from '@/application';
import { logger as log } from '@common/logger';
import { AdminPageService } from '@pages/AdminPage/services';

const getSrv = () => {
  return vappContainer.get<AdminPageService>(AdminPageService.displayName);
};

export const suspendUser = async (context: any, event: any) => {
  const currentState = 'SUSPEND_USER';
  const method = 'suspendUser';

  // @ts-ignore
  return new Promise(async (resolve, reject) => {
    try {
      log.log('context: ', context, 'event: ', event);
      const srv = getSrv();
      const shelves = await srv.agent.getActivateUserSync(event?.payload);
      if (shelves) {
        return resolve({
          key: 'SUSPEND_USER_SUCCESS',
          value: {
            ...(shelves || {}),
          },
        });
      } else {
        const msg = 'Page content not found';
        log.error(`error in ${method}, msg: ${msg}`);
        return reject({
          key: 'SUSPEND_USER_FAILED',
          value: msg,
        });
      }
    } catch (err: any) {
      log.error(`error in ${method}, msg: ${err?.message}`);
      return reject({
        key: 'SUSPEND_USER_FAILED',
        value: err?.message,
      });
    }
  });
};
